import { RequestParams } from '../../interfaces'

/**
 * Takes a map of key/value pairs, and converts them into an Adition-friendly format by wrapping the key in 'prf[]',
 * optionally prefixing it and serializing any string Array values
 * @param data
 * @param prefix
 */
export function getProfileParams(data: RequestParams = {}, prefix = ''): { [key: string]: string } {
  prefix = prefix ? `${prefix}_` : ''
  const map: { [key: string]: string } = {}
  Object.entries(data)
    .filter(([, value]) => {
      return typeof value !== 'undefined'
    })
    .forEach(([key, value]) => {
      map[`prf[${prefix}${key}]`] = value instanceof Array ? value.join('|') : value
    })
  return map
}
